import { storeToRefs } from 'pinia'
import { type InjectionKey } from 'vue'
import { buildDemandeActions } from '../shared'
import { useDemandeAFStore } from './useDemandeAFStore'

type DemandeAFActions = ReturnType<typeof useDemandeAFActions>
export const AF_ACTIONS: InjectionKey<DemandeAFActions> = Symbol('af-actions')

export function useDemandeAFActions() {
  const store = useDemandeAFStore()

  const { estTT } = storeToRefs(store)

  // typeDocumentTemplate: computed(() => null)
  const actionsDemande = buildDemandeActions(store)

  return {
    ...actionsDemande,
    estTypePublicVisible: estTT,
  }
}
